import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const tomos = [{
  emoji: '📕',
  number: 'Tomo 1',
  category: 'URGENCIA',
  title: 'Grietas y alivio inmediato',
  desc: 'El protocolo de emergencia para las primeras 48 horas. Qué hacer ahora cuando duele.'
}, {
  emoji: '📗',
  number: 'Tomo 2',
  category: 'BIOMECÁNICA',
  title: 'El agarre perfecto',
  desc: 'La técnica exacta. Los 7 signos del agarre correcto. Cómo corregir toma a toma.'
}, {
  emoji: '📘',
  number: 'Tomo 3',
  category: 'SUMINISTRO',
  title: 'Producción al máximo',
  desc: 'Cómo funciona la producción real. Qué hacer cuando sentís que "se fue la leche".'
}, {
  emoji: '📙',
  number: 'Tomo 4',
  category: 'RESILIENCIA',
  title: 'El mapa de los brotes',
  desc: 'Semana 3, semana 6, mes 3, mes 6. Qué es una huelga y cómo sobrevivir el cluster feeding.'
}, {
  emoji: '📓',
  number: 'Tomo 5',
  category: 'LIBERTAD',
  title: 'Banco de leche y regreso al trabajo',
  desc: 'Sistema completo de extracción. Conservación. Derechos legales — Art. 179 LCT Argentina.'
}, {
  emoji: '📔',
  number: 'Tomo 6',
  category: 'SOBERANÍA',
  title: 'Destete respetuoso',
  desc: 'Los 30 mitos de la lactancia argentina desmontados. El protocolo de destete gradual y de emergencia.'
}];
const includes = ['Protocolos paso a paso listos para aplicar', 'Semáforos de indicadores visuales', 'Plantillas y trackers completables', 'Scripts para responder al entorno', '100% adaptado al contexto argentino'];
export function ProductTomos() {
  return <section className="py-20 px-4 bg-brand-darker relative" data-id="element-231">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-primary/5 via-brand-darker to-brand-darker pointer-events-none" data-id="element-232" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-233">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-234">
          <h2 className="text-4xl md:text-5xl font-serif text-brand-gold mb-4" data-id="element-235">
            🏆 S.O.S. LACTANCIA — EL PACK COMPLETO
          </h2>
          <p className="text-xl md:text-2xl text-brand-cream-light" data-id="element-236">
            6 Tomos + 6 Bonos — 400+ páginas — Todo resuelto.
          </p>
        </motion.div>

        <div className="text-center mb-10" data-id="element-237">
          <h3 className="text-3xl font-bold text-brand-cream inline-flex items-center gap-3" data-id="element-238">
            <span className="text-4xl" data-id="element-239">🍼</span> LOS 6 TOMOS
          </h3>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-16" data-id="element-240">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-brand-dark p-8 rounded-2xl border border-brand-primary/20 hover:border-brand-primary/50 transition-colors" data-id="element-241">
              <div className="flex items-start gap-4" data-id="element-242">
                <span className="text-5xl shrink-0" data-id="element-243">{tomo.emoji}</span>
                <div data-id="element-244">
                  <div className="flex items-center gap-2 mb-2" data-id="element-245">
                    <span className="text-brand-accent font-bold" data-id="element-246">
                      {tomo.number}
                    </span>
                    <span className="text-brand-primary/60 text-sm" data-id="element-247">—</span>
                    <span className="text-brand-primary text-sm tracking-wider uppercase" data-id="element-248">
                      {tomo.category}
                    </span>
                  </div>
                  <h4 className="text-2xl font-serif text-brand-cream-light mb-3" data-id="element-249">
                    {tomo.title}
                  </h4>
                  <p className="text-brand-cream/80 leading-relaxed" data-id="element-250">
                    {tomo.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-primary/10 border border-brand-primary/30 rounded-2xl p-8 md:p-12 max-w-4xl mx-auto" data-id="element-251">
          <h4 className="text-2xl font-serif text-brand-cream-light mb-6 text-center" data-id="element-252">
            Cada tomo incluye:
          </h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-253">
            {includes.map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-254">
                <CheckCircle2 className="w-6 h-6 text-brand-accent shrink-0" data-id="element-255" />
                <span className="text-brand-cream text-lg" data-id="element-256">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}